import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
import { Loader } from '../../../../components/common/Loader';

interface IProps {
  moduleData: any;
  isLoading: any;
  isView: boolean;
  numberOfDay: number;
}

const TController = ({
  moduleData,
  isView,
  numberOfDay,
  isLoading,
}: IProps) => {
  return (
    <Box>
      <Loader loader={isLoading} />
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
            numberOfDay,
          }}
        />
        <TBody {...{ moduleData, isView }} />
        {/* <TFoot
          preparedBy={moduleData.report_prepared_by}
          approvedBy={moduleData.report_approved_by}
        /> */}
      </RenderTable>
    </Box>
  );
};

export default TController;
